import CardIcon from '@/assets/icons/card.svg?react'
import kakaoIcon from '@/assets/icons/kakao-icon.svg'
import { BottomSheet } from '@/components/ui/BottomSheet'

import { ChevronRight, OptionDesc, OptionIconBox, OptionLabel, OptionList, OptionRow, OptionTextWrap } from './styles'

interface PaymentMethodSelectSheetProps {
  open: boolean
  onClose: () => void
  onSelectCard: () => void
  onSelectKakaopay: () => void
  isPending?: boolean
}

/**
 * 결제수단 등록 BottomSheet (시안 21179-49928).
 *
 *  - 카드 직접 등록 → 행 탭 즉시 CardRegisterPage 라우팅
 *  - 카카오페이    → 행 탭 즉시 카카오페이 등록 API 호출
 */
export function PaymentMethodSelectSheet({
  open,
  onClose,
  onSelectCard,
  onSelectKakaopay,
  isPending = false,
}: PaymentMethodSelectSheetProps) {
  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title='결제수단 등록'
    >
      <OptionList>
        <OptionRow
          type='button'
          onClick={onSelectCard}
        >
          <OptionIconBox>
            <CardIcon
              width={22}
              height={32}
            />
          </OptionIconBox>
          <OptionTextWrap>
            <OptionLabel>카드 직접 등록</OptionLabel>
            <OptionDesc>소유한 카드 직접 등록</OptionDesc>
          </OptionTextWrap>
          <ChevronRight
            width={24}
            height={24}
          />
        </OptionRow>

        <OptionRow
          type='button'
          disabled={isPending}
          onClick={onSelectKakaopay}
        >
          <OptionIconBox>
            <img
              src={kakaoIcon}
              alt=''
              width={32}
              height={32}
            />
          </OptionIconBox>
          <OptionTextWrap>
            <OptionLabel>카카오페이</OptionLabel>
            <OptionDesc>카카오페이로 간편 카드 등록</OptionDesc>
          </OptionTextWrap>
          <ChevronRight
            width={24}
            height={24}
          />
        </OptionRow>
      </OptionList>
    </BottomSheet>
  )
}
